import { ComponentKey } from "../cockpitComponents";
import { defaultRowElementProperties } from "./designer.constants";
import { ElementProperties } from "./designerCSSPropertiesForm/designerCSSPropertiesForm";


export interface videoProperties {
  videoEnabled: boolean;
}

export const defaultVideoProperties: videoProperties = {
  videoEnabled: true,
}

export interface CockpitLayout {
  rows: CockpitRow[];
  videoConfig: videoProperties 
}

export interface CockpitRow {
  id: string;
  height: number;
  columns: GridItem[];
  properties: ElementProperties;
}

export interface GridItem {
  id: string;
  components: GridComponent[];
}

export interface GridComponent {
  id: string;
  name: ComponentKey;
  position: number;
  componentSettings: {
    componentId: string,
    componentName: string
  }
}

export  interface IfourInputs {
  left: number;
  top: number;
  right: number;
  bottom: number;
}

interface ICockpitLayout  {
  videoConfig: videoProperties,

}

export interface ICockpitRow {
  id: string;
  height: number;
  columns: GridItem[];
  properties: ElementProperties;
}

export interface IColumn {
  id: string;
  components: IComponents;
  position: number,
  componentsLength: number;
  parentRowId: string;
}

export interface IComponent {
  id: string,
  position: number,
  name: ComponentKey
}

export interface IComponents {
  [key: string] : GridComponent
}

export interface IColumns {
  [key:string] : IColumn
}

export interface IRows {
  [key:string]: Irow
}

export interface ILayout {
  id: string;
  rowsLength : number;
  rows: IRows,
  videoConfig: videoProperties,
}

export interface Irow {
  columnsLength : number;
  columns: IColumns
  position: number,
  id: string;
  height: number;
  properties: ElementProperties;
}

export interface  IColumnData {
  parentRowId: string,
  components: GridComponent[]
}



export const firstLayout: ILayout = {
  id: crypto.randomUUID(),
  rowsLength: 1,
  videoConfig: defaultVideoProperties,
  rows: {
    'row1': {
      id:'row1',
      height:200,
      properties: defaultRowElementProperties,
      columnsLength:5,
      position: 0,
      columns: {
        'col1': {
          id: 'col1',
          position:0,
          componentsLength:1,
          components: {
            'comp19': {
              id: 'comp19',
              position: 0,
              name: 'pushButton',
              componentSettings:{
                componentId:'string',
                componentName: 'string1'
              }
            }
          },
          parentRowId: 'row1',
        },
        'col2': {
          id: 'col2',
          position:1,
          componentsLength:1,
          components: {
            'comp12': {
              id: 'comp12',
              position: 0,
              name: 'pushButton',
              componentSettings:{
                componentId:'string',
                componentName: 'string1'
              }
            },
            
          },
          parentRowId: 'row1',
        },
        'col3': {
          id: 'col3',
          position:2,
          componentsLength:4,
          components: {
            'comp1': {
              id: 'comp1',
              position: 0,
              name: 'toggleButton',
              componentSettings:{
                componentId:'string',
                componentName: 'string1'
              }
            },
            'comp2': {
              id: 'comp2',
              position: 1,
              name: 'toggleButton',
              componentSettings:{
                componentId:'string',
                componentName: 'string1'
              }
            },
            'comp3': {
              id: 'comp3',
              position: 2,
              name: 'pushButton',
              componentSettings:{
                componentId:'string',
                componentName: 'string1'
              }
            },
            'comp4': {
              id: 'comp4',
              position: 3,
              name: 'toggleButton',
              componentSettings:{
                componentId:'string',
                componentName: 'string1'
              }
            }
          },
          parentRowId: 'row1',
        },
        'col4': {
          id: 'col4',
          position:3,
          componentsLength: 1,
          components: {
            'comp11': {
              id: 'comp11',
              position: 0,
              name: 'pushButton',
              componentSettings:{
                componentId:'string',
                componentName: 'string1'
              }
            }
          },
          parentRowId: 'row1',
        },
        'col5': {
          id: 'col5',
          position:4,
          componentsLength: 1,
          components: {
            'comp111': {
              id: 'comp111',
              position: 0,
              name: 'pushButton',
              componentSettings:{
                componentId:'string',
                componentName: 'string1'
              }
            }
          },
          parentRowId: 'row1',
        }
      }
    },
    'row2': {
      columnsLength:1,
      position:1,
      id:'row2',
      properties: defaultRowElementProperties,
      height: 200,
      columns:{
        'col6': {
          id: 'col6',
          componentsLength:1,
          position:0,
          components: {
            'comp21': {
              id: 'comp21',
              position: 0,
              name: 'pushButton',
              componentSettings:{
                componentId:'string',
                componentName: 'string1'
              }
            }
          },
          parentRowId: 'row2',
        }
      }
    }
  }
}